import { ITypographyComponentProps, TDeviceType, TMemoForwardRefComponent } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { IHowConnectDiscountItem } from 'shared/types/howConnectDiscount';

interface IHowConnectDiscountItemProps extends IHowConnectDiscountItem {
  device: TDeviceType;
  Title: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
  Description: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
}

export const HowConnectDiscountItem: React.FC<IHowConnectDiscountItemProps> = ({
  title,
  descr,
  list,
  imageClass,
  Title,
  Description,
  device,
}) => {
  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={clsx(style['image'], style[imageClass])} />
      <div className={style['text-block']}>
        <div className={style['title']}>
          <Title>{title}</Title>
        </div>
        <div className={style['descr']}>
          <Description>{descr}</Description>
        </div>
        <ul className={style['list']}>
          {list.map((elem, index) => (
            <li key={index} className={style['item']}>
              <Description fontWeight={elem.isBold ? '700' : '500'}>{elem.value}</Description>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
